import { newDateFromUTC, newDateToUTC } from "@bc-library/common";

// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => {
      return afterReceivingOne(object);
    });
  } else if (data.docs && data.count && Array.isArray(data.docs)) {
    data.docs = data.docs.map((object: any) => {
      return afterReceivingOne(object);
    });
  } else if (typeof data == "object") {
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const afterReceivingOne = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      jobs: Array.isArray(object.jobs)
        ? object.jobs.map((job) => {
            return JobFromUTC(job);
          })
        : object.jobs,
      currentJob: object.currentJob && JobFromUTC(object.currentJob),
      futureJob: object.futureJob && JobFromUTC(object.futureJob),
      recruitmentDate: object.recruitmentDate && newDateFromUTC(object.recruitmentDate),
      departureDate: object.departureDate && newDateFromUTC(object.departureDate),
      departureDatePhysical:
        object.departureDatePhysical && newDateFromUTC(object.departureDatePhysical),
      birthdate: object.birthdate && newDateFromUTC(object.birthdate),
      probationEnd1: object.probationEnd1 && newDateFromUTC(object.probationEnd1),
      probationEnd2: object.probationEnd2 && newDateFromUTC(object.probationEnd2),
      workPermits: Array.isArray(object.workPermits)
        ? object.workPermits.map(WorkPermitFromUTC)
        : object.workPermits,
      invitationHistory: Array.isArray(object.invitationHistory)
        ? object.invitationHistory.map(InvitationEntryFromApi)
        : object.invitationHistory,
      _created: object._created && new Date(object._created),
    };
  }
  return object;
};

// OBJECT FIELDS
export const JobFromUTC = (job: any) => {
  return {
    ...job,
    startDate: job?.startDate && newDateFromUTC(job.startDate),
    endDate: job?.endDate && newDateFromUTC(job.endDate),
    startDateLOA: job?.startDateLOA && newDateFromUTC(job.startDateLOA),
    endDateLOA: job?.endDateLOA && newDateFromUTC(job.endDateLOA),
  };
};

export const InvitationEntryFromApi = (entry: any) => {
  if (!entry || typeof entry !== "object") return entry;
  return { ...entry, sentAt: entry.sentAt && new Date(entry.sentAt) };
};

export const WorkPermitFromUTC = (workPermit: any) => {
  if (!workPermit || typeof workPermit !== "object") return workPermit;
  return {
    ...workPermit,
    issueDate: workPermit.issueDate && newDateFromUTC(workPermit.issueDate),
    expirationDate: workPermit.expirationDate && newDateFromUTC(workPermit.expirationDate),
  };
};

export const afterReceivingWorkPermits = (data: any) => {
  if (!data || typeof data !== "object") return data;
  return {
    ...data,
    workPermits: Array.isArray(data.workPermits)
      ? data.workPermits.map(WorkPermitFromUTC)
      : data.workPermits,
  };
};

export const beforeSendingWorkPermits = (data: any) => {
  if (!data || typeof data !== "object") return data;
  return {
    ...data,
    workPermits: Array.isArray(data.workPermits)
      ? data.workPermits.map(WorkPermitToUTC)
      : data.workPermits,
  };
};

// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => {
      return beforeSendingOne(object);
    });
  } else if (typeof data == "object") {
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECTS
export const beforeSendingOne = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      jobs: Array.isArray(object.jobs)
        ? object.jobs.map((job) => {
            return JobToUTC(job);
          })
        : object.jobs,
      currentJob: object.currentJob && JobToUTC(object.currentJob),
      futureJob: object.futureJob && JobToUTC(object.futureJob),
      recruitmentDate: object.recruitmentDate && newDateToUTC(object.recruitmentDate),
      departureDate: object.departureDate && newDateToUTC(object.departureDate),
      departureDatePhysical:
        object.departureDatePhysical && newDateToUTC(object.departureDatePhysical),
      birthdate: object.birthdate && newDateToUTC(object.birthdate),
      probationEnd1: object.probationEnd1 && newDateToUTC(object.probationEnd1),
      probationEnd2: object.probationEnd2 && newDateToUTC(object.probationEnd2),
      workPermits: Array.isArray(object.workPermits)
        ? object.workPermits.map(WorkPermitToUTC)
        : object.workPermits,
    };
  }
  return object;
};

export const beforeSendingCandidate = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      user: {
        ...object.user,
        recruitmentDate: object.user.recruitmentDate && newDateToUTC(object.user.recruitmentDate),
      },
    };
  }
  return object;
};

export const beforeSendingCandidateToResource = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      newJob: object.newJob && JobToUTC(object.newJob),
      resource: object.resource && beforeSendingOne(object.resource),
    };
  }
  return object;
};

export const beforeSendingJobField = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      job: object.job && JobToUTC(object.job),
    };
  }
  return object;
};

// OBJECT FIELDS
export const JobToUTC = (job: any) => {
  return {
    ...job,
    startDate: job?.startDate && newDateToUTC(job.startDate),
    endDate: job?.endDate && newDateToUTC(job.endDate),
    startDateLOA: job?.startDateLOA && newDateToUTC(job.startDateLOA),
    endDateLOA: job?.endDateLOA && newDateToUTC(job.endDateLOA),
  };
};

export const WorkPermitToUTC = (workPermit: any) => {
  if (!workPermit || typeof workPermit !== "object") return workPermit;
  return {
    ...workPermit,
    issueDate: workPermit.issueDate && newDateToUTC(workPermit.issueDate),
    expirationDate: workPermit.expirationDate && newDateToUTC(workPermit.expirationDate),
  };
};

// UTILITIES

const sortJobsByStartDate = (jobs) => {
  return jobs.sort((a, b) => {
    if (a.startDate > b.startDate) return -1;
    if (a.startDate < b.startDate) return 1;
    return 0;
  });
};
